import { Button, Col, Image, Row } from 'antd';
import { AppConfigs } from '../../../shared/config';

export const LoginWithSocial = () => {
  const login = (type) => {
    window.location.href = `${AppConfigs.apiUrl}/auth/${type}`;
  };

  return (
    <Row>
      {/* <Col>
        <Button type='link' onClick={() => login('facebook')}>
          <Image width={64} preview={false} src='/assets/images/Facebook.png' />
        </Button>
      </Col> */}
      <Col>
        <Button type='link' onClick={() => login('linkedin')}>
          <Image width={64} preview={false} src='/assets/images/Linkedin.png' />
        </Button>
      </Col>
      <Col>
        <Button type='link' onClick={() => login('google')}>
          <Image width={64} preview={false} src='/assets/images/Google.png' />
        </Button>
      </Col>
    </Row>
  );
};
